export default __webpack_public_path__ + "static/media/productImg.ff2d0773.png";